<template>
    <!-- <tab-content title="Select Employees" class="mb-5" :before-change="validateStep2"> -->
        
            <!-- <div :class="createSchedule.createScheduleTypeId === 2 ? 'vx-row pointer-events-none' : 'vx-row'" > -->
            <!-- <div v-if="createSchedule != null" class="vx-row">
                <vx-card title="Select Employees" code-toggler> -->
                    <vs-table multiple  v-model="selected" @selected="handleSelected"  :data="getAllEmployeeByStatus" stripe pagination :max-items="10" search   >
                        <template slot="header">
                            <h3>
                            Employees
                            </h3>
                        </template>
                        <template slot="thead">
                            <vs-th>Code</vs-th>
                            <vs-th>Name</vs-th>
                            <vs-th>Employee Status</vs-th>
                            <vs-th>Employment Status</vs-th>
                            <vs-th>Date Joined</vs-th>
                            <vs-th>Date Start</vs-th>
                            <vs-th>Date Resigned</vs-th>
                            <vs-th>Date Terminated</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].employeeCode">
                                    {{ data[indextr].employeeCode }}
                                </vs-td>
                                <vs-td :data="data[indextr].fullName">
                                    {{ data[indextr].fullName }}
                                </vs-td>
                                <vs-td :data="data[indextr].employeeInformation.employeeStatus">
                                    {{ empStatusName(data[indextr].employeeInformation.employeeStatus).status }}
                                </vs-td>
                                <vs-td :data="data[indextr].employeeInformation.employmentStatus">
                                    {{employStatusName(data[indextr].employeeInformation.employmentStatus).employStatus }}
                                </vs-td>
                                <vs-td :data="data[indextr].employeeInformation.dateJoined">
                                    {{ data[indextr].employeeInformation.dateJoined | fulldate }}
                                </vs-td>
                                <vs-td :data="data[indextr].employeeInformation.dateStart">
                                    {{ data[indextr].employeeInformation.dateStart | fulldate }}
                                </vs-td>
                                <vs-td :data="data[indextr].employeeInformation.dateResigned">
                                    {{ data[indextr].employeeInformation.dateResigned | fulldate }}
                                </vs-td>
                                <vs-td :data="data[indextr].employeeInformation.dateTerminated">
                                    {{ data[indextr].employeeInformation.dateTerminated | fulldate }}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                <!-- </vx-card>
            </div> -->
    <!-- </tab-content> -->
</template>
<script>
export default {
    props: {
        createSchedule: {
            type: Object,
            required: false
        },
        isValidate2: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            selected: []

        }
    },
    watch: {
        isValidate2(value) {
            if(value) {
                this.onGetAllEmployeeByStatus() 
            }
                
        }
    },
    computed: {
        getAllEmployeeByStatus() {
            return this.$store.state.scheduleEmployeesToProcess
        },
        empStatusName()  {
            return (id) => this.$store.getters['lookup/empStatus'](id)
        },
        employStatusName()  {
            return (id) => this.$store.getters['lookup/employStatus'](id)
      },

    },
    methods: {
        onGetAllEmployeeByStatus() {
             if(this.createSchedule != null) {
                // console.log(this.$store.state.AppActiveUser.uid)
                const employeesToProcess = this.$store.getters['hrms/getEmployeeByImmediateSupervisor'](this.$store.state.AppActiveUser.uid)
         
                this.$store.commit('SCHEDULEEMPLOYEESTOPROCESS', employeesToProcess)

                // this.selected = employeesToProcess
                // this.$store.commit('SCHEDULESELECTEDEMPLOYEES', this.selected)
            }
        },
        handleSelected(tr) {
            console.log('belat')
            this.$store.commit('SCHEDULESELECTEDEMPLOYEES', tr)
            // this.$emit('selected-employees', this.selected)
            
        },
        onSelectDeselectAll() {

        }
    }
    
}
</script>